import moment from 'moment';
import store from '@/store/index';
import { defaultOperatingHour } from "@/store/modules/StandardOperatingHoursModule";
export default class OperatingHoursMapper {
    static getByDay(date) {
        const specialOperatingHours = [...store.getters['specialOperatingHours/old'], ...store.getters['specialOperatingHours/all']];
        const specialHour = specialOperatingHours.find((operatingHour) => {
            const validFrom = moment(operatingHour.data.validFrom)
                .hours(0)
                .minutes(0)
                .seconds(0);
            const validTo = moment(operatingHour.data.validTo)
                .hours(23)
                .minutes(59)
                .seconds(59);
            return date.isSameOrAfter(validFrom) && date.isSameOrBefore(validTo);
        });
        if (specialHour) {
            return specialHour.data;
        }
        return store.getters['standardOperatingHours/all'].reduce((last, current) => {
            return current.data.validFrom > last.data.validFrom
                && date.format('YYYY-MM-DD') >= current.data.validFrom
                ? current
                : last;
        }, defaultOperatingHour).data.days.find((val) => val.number === date.day());
    }
}
